import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { UserProvider, useUser } from "./contexts/UserContext";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Feed from "./pages/Feed";
import Compose from "./pages/Compose";
import PostDetail from "./pages/PostDetail";
import Moderation from "./pages/Moderation";
import Events from "./pages/Events";
import Notifications from "./pages/Notifications";
import AdminCategories from "./pages/AdminCategories";
import Me from "./pages/Me";
import DevSwitchUser from "./pages/DevSwitchUser";
import Layout from "./components/Layout";
import { Loader2 } from "lucide-react";
import "./App.css";

function Protected({ children, allowedLevels }) {
  const { user, loading } = useUser();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="animate-spin" color="#F77F00" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (allowedLevels && !allowedLevels.includes(user.hierarchy_level))
    return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <UserProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/dev/switch-user" element={<DevSwitchUser />} />
          <Route path="/" element={<Protected><Feed /></Protected>} />
          <Route path="/compose" element={<Protected><Compose /></Protected>} />
          <Route path="/posts/:id" element={<Protected><PostDetail /></Protected>} />
          <Route path="/moderation" element={<Protected allowedLevels={["ceo","direction","dn","dr"]}><Moderation /></Protected>} />
          <Route path="/events" element={<Protected><Events /></Protected>} />
          <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
          <Route path="/me" element={<Protected><Me /></Protected>} />
          <Route path="/admin/categories" element={<Protected allowedLevels={["ceo","direction"]}><AdminCategories /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </UserProvider>
  );
}

export default App;
